// extracted by mini-css-extract-plugin
module.exports = {"heading":"_f8de049","mediaGridItem":"_5206712","textWrapper":"_39c8fc7"};